import { instance3 } from "App/constants";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

export const STYLE_KAS_BANK = makeStyles({
  root: {
    width: "100%",
  },
  paper: {
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
    padding: "1rem 1.5rem",
  },
  table: {
    width: "97%",
    margin: "0 auto",
  },
});

export const RESET_STATE_KAS_BANK = {
  id: "",
  nama: "",
  jumlah: "0",
  jumlah2: "0",
  norek: "",
  nocontactperson: "",
  notelp: "",
};

export const getAllKasBank = async () => {
  try {
    const api = await instance3.get("/kas/read");
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const deleteKasBankById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance3.post(
      "/kas/delete",
      {},
      {
        headers: {
          idkasbank: id,
        },
      }
    );
    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_KAS_BANK);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "norek",
    disablePadding: false,
    label: "NO REKENING",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nocontactperson",
    disablePadding: false,
    label: "CONTACT PERSON",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "notelp",
    disablePadding: false,
    label: "NO TELP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
